export default __webpack_public_path__ + "static/media/regulatory--high-beam-headlights--g1.e09c5b20.png";